import { useCallback, useEffect } from "react";
import { useLocation } from "react-router";

const STORAGE_KEY = "da:lastProductsUrl";
const FALLBACK = "/products";

export function usePersistProductsUrl(serializedFilters: string | null): void {
	const location = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (serializedFilters) {
			params.set("filters", serializedFilters);
		}
		const search = params.toString();
		const url = `${location.pathname}${search ? `?${search}` : ""}`;
		sessionStorage.setItem(STORAGE_KEY, url);
	}, [location.pathname, location.search, serializedFilters]);
}

export function useBackToShoppingUrl(): () => string {
	return useCallback(() => {
		if (typeof window === "undefined") {
			return FALLBACK;
		}
		return sessionStorage.getItem(STORAGE_KEY) ?? FALLBACK;
	}, []);
}
